import { DraftProctorRequestEditionFormProvider } from '../../providers';
import { DraftProctorRequestEditionFormLogic } from '../draft-proctor-request-edition-form-logic';

export default function DraftProctorRequestDetails() {
  return (
    <DraftProctorRequestEditionFormProvider>
      <DraftProctorRequestEditionFormLogic />
    </DraftProctorRequestEditionFormProvider>
  );
}
